import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useTranslation } from 'react-i18next';
import NavBar from './componance/NavBar';
import Footer from './componance/Footer';
import ContactPopupWithArrow from './componance/ContactPopupWithArrow';
import LoginModal from './componance/Login/LoginModal';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropertyListFav from './Propertylist/PropertyListFav';
import PropertyImagesModal from './componance/Modal/PropertyImagesModal';
import i18n from './i18n';
import DetailModalHeader from './componance/Modal/DetailModalHeader';
import DetailModalProperty from './componance/Modal/DetailModalProperty';
import EstimatedYield from './componance/Modal/EstimatedYield';
import SearchForm from './componance/Search/SearchForm';
import PropertyListContainerBuy from './Propertylist/PropertyListContainerBuy';
function BuyPage() {
  const { t } = useTranslation();

  // States
  const [showFavDrawer, setShowFavDrawer] = useState(false);
  const [userId, setUserId] = useState(null);
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [favoriteProperties, setFavoriteProperties] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [currency, setCurrency] = useState(localStorage.getItem('currency') || 'THB');

  // Filters
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedType, setSelectedType] = useState('all');
  const [propertyStatus, setPropertyStatus] = useState('all'); // แก้ชื่อ status

  const [bedroomFilter, setBedroomFilter] = useState(null);


  const [, setLocations] = useState([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const shuffleArray = (array) => {
  return [...array].sort(() => Math.random() - 0.5);
};
const randomProperties = shuffleArray(filteredProperties);
 const [searchResults, ] = useState([]);
  // Responsive check
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ดึง userId จาก JWT
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded.userId || decoded.user_id);
      } catch (err) { console.error(err); }
    }
  }, []);

  // โหลด properties Buy
  useEffect(() => {
    fetch('https://summerhousagentlive.onrender.com/api/properties')
      .then(res => res.json())
      .then(data => {
        const buyProps = data.filter(p => p.status === 'Buy');
        setProperties(buyProps);
        setFilteredProperties(buyProps);
        setLocations([...new Set(buyProps.map(p => p.location))]);
      });
  }, []);

  // โหลด favorites
  useEffect(() => {
    if (!userId) return;
    fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}`)
      .then(res => res.json())
      .then(data => setFavoriteProperties(data))
      .catch(err => console.error(err));
  }, [userId]);

  // ป้องกัน scroll หน้าเมื่อ modal เปิด
  useEffect(() => {
    document.body.style.overflow = isModalOpen ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; }
  }, [isModalOpen]);

 

  const openModal = (property) => { setSelectedProperty(property); setIsModalOpen(true); };
  const closeModal = () => { setIsModalOpen(false); setSelectedProperty(null); };

  const toggleFavorite = (property) => {
    if (!userId) { setShowLoginPopup(true); return; }

    const isFav = favoriteProperties.some(fav => fav.property_id === property.property_id);

    if (isFav) {
      fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}/${property.property_id}`, { method: 'DELETE' })
        .then(() => setFavoriteProperties(prev => prev.filter(fav => fav.property_id !== property.property_id)));
    } else {
      fetch(`https://summerhousagentlive.onrender.com/api/favorites`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, property_id: property.property_id })
      }).then(() => setFavoriteProperties(prev => [...prev, property]));
    }
  };

  return (
    <div style={styles.container}>
      <NavBar currency={currency} setCurrency={setCurrency} />

      <h1 style={{
        fontSize:'36px', fontWeight:'bold', margin:'40px 0 20px 0',
        textTransform:'uppercase', letterSpacing:'1.2px',
        textAlign:'center', borderBottom:'3px solid #f3d44fff', paddingBottom:'8px'
      }}>
        {t("Buy Properties")}
      </h1>

      <div
          style={{
            display: 'flex',
            flexDirection: isDesktop ? 'row' : 'column', // ← responsive
            gap: '20px',
            padding: '20px',
            width: '100%',
            maxWidth: '1200px',
          }}
        >
          {/* Sidebar Filters */}
          <div style={{ flex: 1 }}>
            <h1 style={styles.header}>{t('feature_search')}</h1>
            <SearchForm
              properties={properties} // ต้องมี array ของ property แต่ละตัว {name, price, location, type, status, bedrooms}
              selectedLocations={selectedLocations}
              setSelectedLocations={setSelectedLocations}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              status={propertyStatus}
              setStatus={setPropertyStatus}
              bedroomFilter={bedroomFilter}
              setBedroomFilter={setBedroomFilter}
              setFilteredProperties={setFilteredProperties} // ต้องมี function สำหรับรับ filtered list
            />

          </div>

          {/* Property List */}
          <div style={{ flex: 5, display: 'grid' }}>
            <h1 style={{ flex: 5, alignItems:'center', margin:'auto', padding:'40px 40px'}}>{t('PropertyList')}</h1>
           <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
              {t('property.total', { count: filteredProperties.length })}
            </p>
             <div id="searchResults">
            <PropertyListContainerBuy
            
                                 filteredProperties={randomProperties} 
                                openModal={openModal}
                                favoriteProperties={favoriteProperties}
                                toggleFavorite={toggleFavorite}
                                currency={currency}
                                results={searchResults}
            />
            </div>
          </div>
        </div>


      {isModalOpen && selectedProperty && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.6)',
              zIndex: 1000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={closeModal}
          />
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '16px',
              padding: '24px',
              width: '95%',
              maxWidth: '700px',
              maxHeight: '90vh',
              overflowY: 'auto',
              boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1100,
              color: 'black',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <DetailModalHeader
              closeModal={closeModal}
              selectedProperty={selectedProperty}
              t={t}
              i18n={i18n}
            />

            {selectedProperty.images && selectedProperty.images.length > 0 && (
              <div
                style={{
                  width: '100%',
                  maxWidth: '650px',
                  height: '400px',
                  margin: '10px auto 20px auto',
                  overflow: 'hidden',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                }}
              >
                <PropertyImagesModal
                  images={selectedProperty.images}
                  propertyName={selectedProperty.name}
                />
              </div>
            )}

            <DetailModalProperty
              selectedProperty={selectedProperty} onClose={closeModal} currency={currency} 
              t={t}
            />

            {selectedProperty && <EstimatedYield selectedProperty={selectedProperty} />}

            <button
              onClick={closeModal}
              style={{
                marginTop: '20px',
                backgroundColor: '#1a2e35',
                color: '#fff',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0f1c20')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1a2e35')}
            >
              {t("close")}
            </button>
          </div>
        </>
      )}

      {/* Floating button */}
      <button
        onClick={() => setShowFavDrawer(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          backgroundColor: "rgba(30, 62, 93, 0.8)",
          color: "#fff",
          padding: "15px 20px",
          borderRadius: "50%",
          border: "none",
          cursor: "pointer",
          zIndex: 1200
        }}
      >
        ❤️
      </button>

      {/* Drawer */}
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: showFavDrawer ? "0" : "-100%",
          height: "60vh",
          backgroundColor: "#fff",
          boxShadow: "0 -4px 12px rgba(191, 173, 173, 0.2)",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          transition: "bottom 0.4s ease-in-out",
          zIndex: 1100,
          overflowY: "auto",
          padding: "20px"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0 }}>{t("favorite_property")}</h2>
          <button
            onClick={() => setShowFavDrawer(false)}
            style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer" }}
          >
            ✕
          </button>
        </div>

        <PropertyListFav 
          favorites={favoriteProperties}
          openModal={openModal}
          toggleFavorite={toggleFavorite}  
          currency={currency}
        />
      </div>

      <Footer />
      {showLoginPopup && <LoginModal onClose={()=>setShowLoginPopup(false)} />}
      <ContactPopupWithArrow />
    </div>
  );
}

const styles = {
  container: {
        display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px',
    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '100vh',
    width: '100%',
    maxWidth: '100vw',         // ✅ ป้องกันเกินขนาดจอ
    overflowX: 'hidden',       // ✅ ป้องกันการเลื่อนแนวนอน
    boxSizing: 'border-box',   // ✅ คำนวณ padding ไม่ให้ล้น
  },
};

export default BuyPage;
